import I18N from '@leverege/i18n';
import Path from '@leverege/path';
const path = 'metadata/notes';
const i18n = I18N.ns(`openApi.blueprint.SaleJobService.saleJob.attributes.${path}`);
const p = Path(path);
export default {
  name: path,
  path,
  objectType: 'SaleJobService.saleJob',
  valueType: 'string',
  get displayName() {
    return i18n.t('name', 'Notes', {
      count: 1
    });
  },
  source: {
    type: 'SaleJobService',
    model: {},
    editOptions: {
      formSort: 'ab'
    },
    createOptions: {
      formSort: 'ab'
    },
    creatable: true,
    editable: true,
    sortable: false,
    filterable: false
  },
  get: (data, cxt) => {
    return p.get(data, '');
  },
  canSet: () => true,
  set: (data, value, cxt) => {
    return p.copy(data, value);
  },
  getPatch: (data, value, cxt) => {
    return {
      path,
      value
    };
  },
  getString: () => null,
  getDescription: () => null,
  getOption: optionName => {
    return null;
  }
};